// src/Calculators/CommonComponents/FinanceLayout.jsx
import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import './FinancialCalculators.css';


// Finance Calculators
import SIPCalculator from "../../Calculators/Pages/SipCalculator/SIPCalculator.jsx";
import MutualFundCalculator from "../../Calculators/Pages/MutualFund/MutualFundCalculator.jsx";
import CompoundInterestCalculator from "../../Calculators/Pages/CompoundInterest/CompoundInterestCalculator.jsx";
import DCFCalculator from "../../Calculators/Pages/DCFCalculator/DCFCalculator.jsx";
import EMICalculator from "../../Calculators/Pages/EmiCalculator/EmiCalculator.jsx";
import SimpleInterestCalculator from "../Pages/SimpleInterestCalculator/SimpleInterestCalculator.jsx";
import FDCalculator from "../Pages/FDCalculator/FixedDepositCalculator.jsx";
import RDCalculator from "../Pages/RDCalculator/RecurringDeposit.jsx";
import PPFCalculator from "../Pages/PPFCalculator/PPFCalculator.jsx";
import NPSCalculator from "../Pages/NPSCalculator/NPSCalculator.jsx";
import SSYCalculator from "../Pages/SSYCalculator/SukanyaSamriddhiCalculator.jsx";
import RetirementCorpusCalculator from "../Pages/RetirementCorpusCalculator/RetirementCorpusCalculator.jsx";
import GoalBasedInvestmentCalculator from "../Pages/GoalBasedInvestmentCalculator/GoalBasedInvestmentCalculator.jsx";
import LoanAmortizationCalculator from "../Pages/LoanAmoritizationCalculator/LoanAmortizationCalculator.jsx";
import LoanEligibilityCalculator from "../Pages/LoanEligibilityCalculator/LoanEligibilityCalculator.jsx";
import PrepaymentImpactCalculator from "../Pages/PrepaymentImpactCalculator/PrepaymentImpactCalculator.jsx";
import BalanceTransferCalculator from "../Pages/BalanceTransferCalculator/BalanceTransferCalculator.jsx";
import CreditCardInterestCalculator from "../Pages/CreditCardInterestCalculator/CreditCardInterestCalculator.jsx";
import DebtToIncomeRatioCalculator from "../Pages/DebtToIncomeRatioCalculator/DebtToIncomeRatioCalculator.jsx";
import ROICalculator from "../Pages/ROICalculator/ROICalculator.jsx";
import BreakEvenCalculator from "../Pages/BreakEvenCalculator/BreakEvenCalculator.jsx";
import ProfitMarginCalculat from "../Pages/ProfitMarginCalculator/ProfitMarginCalculator.jsx";
import NPVCalculator from "../Pages/NPVCalculator/NPVCalculator.jsx";
import IRRCalculator from "../Pages/IRRCalculator/IRRCalculator.jsx";
import IncomeTaxCalculator from "../Pages/IncomeTaxCalculator/IncomeTaxCalculator.jsx";
import GSTCalculator from "../Pages/GSTCalculator/GSTCalculator.jsx";
import HRAExemptionCalculator from "../Pages/HRA/HRAExemptionCalculator.jsx";
import GratuityCalculator from "../Pages/GratuityCalculator/GratuityCalculator.jsx";
import PFCalculator from "../Pages/PFCalculator/PFCalculator.jsx";
import TDSCalculator from "../Pages/TDSCalculator/TDSCalculator.jsx";
import CapitalGainsTaxCalculator from "../Pages/CapitalGainsTaxCalculator/CapitalGainsTaxCalculator.jsx";
import UnitConverterCalculator from "../Pages/UnitConverterCalculator/UnitConverterCalculator.jsx";
import TipCalculator from "../Pages/TipCalculator/TipCalculator.jsx";
import DiscountCalculator from "../Pages/DiscountCalculator/DiscountCalculator.jsx";
import PercentageCalculator from "../Pages/PercentageCalculator/PercentageCalculator.jsx";
import AgeCalculator from "../Pages/AgeCalculator/AgeCalculator.jsx";
import DateDifferenceCalculator from "../Pages/DateDifferenceCalculator/DateDifferenceCalculator.jsx";
import SalaryCalculator from "../Pages/SalaryCalculator/SalaryCalculator.jsx";
import BMICalculator from "../Pages/BMICalculator/BMICalculator.jsx";
import CurrencyConverterCalculator from "../Pages/CurrencyConverterCalculator/CurrencyConverterCalculator.jsx";
import BMRCalculator from "../Pages/BMRCalculator/BMRCalculator.jsx";
import CalorieIntakeCalculator from "../Pages/CalorieIntakeCalculator/CalorieIntakeCalculator.jsx";
import IdealWeightCalculator from "../Pages/IdealWeightCalculator/IdealWeightCalculator.jsx";
import BodyFatCalculator from "../Pages/BodyFatCalculator/BodyFatCalculator.jsx";
import HeartRateZoneCalculator from "../Pages/HeartRateZoneCalculator/HeartRateZoneCalculator.jsx";
import PregnancyDueDateCalculator from "../Pages/PregnancyDueDateCalculator/PregnancyDueDateCalculator.jsx";
import InvoiceCalculator from "../Pages/InvoiceCalculator/InvoiceCalculator.jsx";
import InventoryValuationCalculator from "../Pages/InventoryValuationCalculator/InventoryValuationCalculator.jsx";
import DepreciationCalculator from "../Pages/DepreciationCalculator/DepreciationCalculator.jsx";
import ProfitCalculator from "../Pages/ProfitCalculator/ProfitCalculator.jsx";
import LoanVsLeaseCalculator from "../Pages/LoanVsLeaseCalculator/LoanVsLeaseCalculator.jsx";
import CAGRCalculator from "../Pages/CAGRCalculator/CAGRCalculator.jsx";
import EBITDACalculator from "../Pages/EBITDACalculator/EBITDACalculator.jsx";
import PercentageChangeCalculator from "../Pages/PercentageChangeCalculator/PercentageChangeCalculator.jsx";
import FuelCostCalculator from "../Pages/FuelCostCalculator/FuelCostCalculator.jsx";
import ElectricityBillEstimator from "../Pages/ElectricityBillEstimator/ElectricityBillEstimator.jsx";
import TimeDurationCalculator from "../Pages/TimeDurationCalculator/TimeDurationCalculator.jsx";
import SavingsGoalTimelineCalculator from "../Pages/SavingsGoalTimelineCalculator/SavingsGoalTimelineCalculator.jsx";
import CurrencyInflationAdjusterCalculator from "../Pages/CurrencyInflationAdjusterCalculator/CurrencyInflationAdjusterCalculator.jsx";

import "./FinanceLayout.css";


const FinanceLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="finance-layout">
      {/* Header */}
      <Header toggleSidebar={toggleSidebar} />

      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <main className={`main-content ${isSidebarOpen ? "shifted" : ""}`}>
        <div className="content-wrapper">
          <div className="calculator-container">
            <Routes key={location.pathname}>
              <Route path="sip" element={<SIPCalculator />} />
              <Route path="mutual" element={<MutualFundCalculator />} />
              <Route path="compound" element={<CompoundInterestCalculator />} />
              <Route path="emi" element={<EMICalculator />} />
              <Route path="dcf" element={<DCFCalculator />} />
              <Route path="simple" element={<SimpleInterestCalculator />} />
              <Route path="fd" element={<FDCalculator />} />
              <Route path="rd" element={<RDCalculator />} />
              <Route path="ppf" element={<PPFCalculator />} />
              <Route path="nps" element={<NPSCalculator />} />
              <Route path="ssy" element={<SSYCalculator />} />
              <Route path="retirement" element={<RetirementCorpusCalculator />} />
              <Route path="goal" element={<GoalBasedInvestmentCalculator />} />
              <Route path="loan" element={<LoanAmortizationCalculator />} />
              <Route path="loanEligibility" element={<LoanEligibilityCalculator />} />
              <Route path="prepayment" element={<PrepaymentImpactCalculator />} />
              <Route path="balance" element={<BalanceTransferCalculator />} />
              <Route path="credit" element={<CreditCardInterestCalculator />} />
              <Route path="debt" element={<DebtToIncomeRatioCalculator />} />
              <Route path="roi" element={<ROICalculator />} />
              <Route path="break" element={<BreakEvenCalculator />} />
              <Route path="profit" element={<ProfitMarginCalculat />} />
              <Route path="npv" element={<NPVCalculator />} />
              <Route path="irr" element={<IRRCalculator />} />
              <Route path="dcf" element={<DCFCalculator />} />
              <Route path="income" element={<IncomeTaxCalculator />} />
              <Route path="GST" element={<GSTCalculator />} />
              <Route path="hra" element={<HRAExemptionCalculator />} />
              <Route path="gratuity" element={<GratuityCalculator />} />
              <Route path="pf" element={<PFCalculator />} />
              <Route path="tds" element={<TDSCalculator />} />
              <Route path="capital" element={<CapitalGainsTaxCalculator />} />
              <Route path="unit" element={<UnitConverterCalculator />} />
              <Route path="tip" element={<TipCalculator />} />
              <Route path="discount" element={<DiscountCalculator />} />
              <Route path="percentage" element={<PercentageCalculator />} />
              <Route path="age" element={<AgeCalculator />} />
              <Route path="date" element={<DateDifferenceCalculator />} />
              <Route path="salary" element={<SalaryCalculator />} />
              <Route path="currency" element={<CurrencyConverterCalculator />} />
              <Route path="bmi" element={<BMICalculator />} />
              <Route path="bmr" element={<BMRCalculator />} />
              <Route path="calorie" element={<CalorieIntakeCalculator />} />
              <Route path="ideal" element={<IdealWeightCalculator />} />
              <Route path="heart" element={<HeartRateZoneCalculator />} />
              <Route path="body" element={<BodyFatCalculator />} />
              <Route path="pregnancy" element={<PregnancyDueDateCalculator />} />
              <Route path="invoice" element={<InvoiceCalculator />} />
              <Route path="inventory" element={<InventoryValuationCalculator />} />
              <Route path="depreciation" element={<DepreciationCalculator />} />
              <Route path="gross" element={<ProfitCalculator />} />
              <Route path="loanvslease" element={<LoanVsLeaseCalculator />} />
              <Route path="cagr" element={<CAGRCalculator />} />
              <Route path="ebitda" element={<EBITDACalculator />} />
              <Route path="PercentageChange" element={<PercentageChangeCalculator />} />
              <Route path="fuel" element={<FuelCostCalculator />} />
              <Route path="time" element={<TimeDurationCalculator />} />
              <Route path="electricity" element={<ElectricityBillEstimator />} />
              <Route path="savings" element={<SavingsGoalTimelineCalculator />} />
              <Route path="inflation" element={<CurrencyInflationAdjusterCalculator />} />
      </Routes>
      <Footer />
      </div>
      </div>
      </main>
    </div>
  );
};

export default FinanceLayout;